<template>
  <ForieLoader v-show="showLoader && this.$store.state.domainSystemX == 1" />
  <TeLoader v-show="showLoader && this.$store.state.domainSystemX == 2" />

  <div class="container mt-2">
    <div class="row mb-4">
      <div class="col-md-9">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-2">
                <img class="company-logo" v-bind:src="logo" alt="" />
              </div>
              <div class="col-md-10 mt-4">
                <h2>
                  <b>{{ companyName }}</b>
                </h2>

                <div class="company-info d-flex">
                  <div class="company-country mt-1 d-flex">
                    <country-flag :country="companyCountryCode" size="small" />
                    <small>{{ companyCountry }}</small>
                  </div>
                  <span class="separator">|</span>
                  <div v-show="isVip" class="is-company-vip">
                    <i class="fas text-warning fa-gem"></i>
                    <small>{{
                      this.$store.getters.getWordLocale("txt_vip_uye")
                    }}</small>
                  </div>

                  <div v-show="!isVip" class="is-company-vip">
                    <i class="fas fa-suitcase"></i>
                    <small>{{
                      this.$store.getters.getWordLocale("txt_standart_uye")
                    }}</small>
                  </div>
                </div>

                <div class="languages float-end">
                  <country-flag
                    v-for="(profile, index) in profiles"
                    :key="index"
                    v-show="
                      this.$store.state.domainLanguages.filter(
                        (q) => q.LangCode == profile
                      ).length > 0
                    "
                    :class="
                      this.$store.state.langCodeX == profile
                        ? 'selected-lang header-language'
                        : 'header-language'
                    "
                    v-on:click="changeLanguage(profile)"
                    :country="
                      profile == 'en' ? 'gb' : profile == 'ar' ? 'sa' : profile
                    "
                    size="normal"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_firma_hakkinda") }}</b>
          </div>
          <div class="card-body">
            <p
              v-html="
                fullDescription == false
                  ? `${
                      companyDescription != null
                        ? companyDescription.substr(0, 250)
                        : companyDescription
                    } ...`
                  : companyDescription
              "
            ></p>
            <b
              v-on:click="fullDescription = true"
              v-show="fullDescription == false"
              class="read-more"
              >{{ this.$store.getters.getWordLocale("txt_devamini_oku") }}</b
            >
          </div>
        </div>

        <div v-show="companyProducts.length > 0" class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_firma_urunleri") }}</b>
          </div>
          <div class="card-body">
            <Carousel
              v-if="companyProducts.length > 0"
              :autoplay="2000"
              :items-to-show="2.5"
              :wrap-around="true"
            >
              <Slide v-for="(product, index) in companyProducts" :key="index">
                <div class="carousel__item">
                  <img
                    :title="product.fullTitle"
                    :src="'https://cdn.turkishexporter.com.tr' + product.image"
                    alt=""
                  />
                  <small :title="product.fullTitle" class="text-danger">{{
                    product.title
                  }}</small>
                </div>
              </Slide>

              <template #addons>
                <Navigation />
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{
              this.$store.getters.getWordLocale("txt_anahtar_kelimeleri")
            }}</b>
          </div>
          <div class="card-body">
            <div
              v-show="
                companyKeywords != null
                  ? companyKeywords.filter((q) => q != '').length > 0
                  : false
              "
              class="company-keywords"
            >
              <span v-for="(keyword, i) in companyKeywords" :key="i">
                {{ keyword }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <div class="contact-supplier">
            <i class="far fa-envelope" style="color: #ffe359"></i>
            {{ this.$store.getters.getWordLocale("txt_firmaya_mesaj_gonder") }}
          </div>
          <div class="card-body">
            <div class="form-data">
              <input
                v-show="!this.$store.state.userLoggedInX"
                v-on:keyup="checkNameSurname($event)"
                v-on:focusout="checkNameSurname($event)"
                maxlength="35"
                v-bind:class="{
                  'form-control': true,
                  'is-invalid': !isNameValid && nameBlured,
                  'is-valid': isNameValid && nameBlured,
                }"
                v-model="senderNameSurname"
                type="text"
                v-on:blur="nameBlured = true"
                :placeholder="
                  this.$store.getters.getWordLocale('txt_adi_soyadi')
                "
              />
              <div
                v-show="!this.$store.state.userLoggedInX"
                v-bind:class="{
                  'float-end': true,
                  'text-danger': senderNameSurname.length == 35,
                  'char-count': true,
                }"
              >
                {{ senderNameSurname.length }}/35
              </div>
              <div class="invalid-feedback" v-show="!isNameValid">
                {{ this.$store.getters.getWordLocale("txt_adinizi_giriniz") }}
              </div>

              <input
                type="text"
                v-show="!this.$store.state.userLoggedInX"
                v-model="senderEmail"
                v-on:keyup="checkEmail($event)"
                v-on:focusout="checkEmail($event)"
                v-bind:class="{
                  'mt-4': true,
                  'form-control': true,
                  'is-invalid': !isEmailValid && emailBlured,
                  'is-valid': isEmailValid && emailBlured,
                }"
                v-on:blur="emailBlured = true"
                :placeholder="
                  this.$store.getters.getWordLocale('txt_eposta_adresi')
                "
              />
              <div class="invalid-feedback" v-show="!isEmailValid">
                {{
                  this.$store.getters.getWordLocale(
                    "txt_gecerli_eposta_adresi_giriniz"
                  )
                }}
              </div>

              <Select2
                v-bind:class="{
                  'mt-4': true,
                }"
                :options="countries"
                v-model="selectedCountry"
                @select="setSelectedCountry($event.id)"
              />

              <input
                type="text"
                v-model="subject"
                v-on:keyup="checkSubject($event)"
                v-on:focusout="checkSubject($event)"
                maxlength="50"
                v-bind:class="{
                  'form-control': true,
                  'mt-4': true,
                  'is-invalid': !isSubjectValid && subjectBlured,
                  'is-valid': isSubjectValid && subjectBlured,
                }"
                v-on:blur="subjectBlured = true"
                :placeholder="this.$store.getters.getWordLocale('txt_konu')"
              />
              <div
                v-bind:class="{
                  'float-end': true,
                  'text-danger': subject.length == 50,
                  'char-count': true,
                }"
              >
                {{ subject.length }}/50
              </div>
              <div class="invalid-feedback" v-show="!isSubjectValid">
                {{ this.$store.getters.getWordLocale("txt_konu_giriniz") }}
              </div>

              <textarea
                :data-bs-toggle="
                  optionalFieldsCollapsed == false ? 'collapse' : ''
                "
                maxlength="700"
                minlength="6"
                ref="messageTxtArea"
                href="#optional-fields"
                v-model="message"
                v-on:keyup="checkMessage($event)"
                v-on:focusout="checkMessage($event)"
                v-on:focusin="collapseOptionalFileds"
                v-bind:class="{
                  'form-control': true,
                  'mt-4': true,
                  'is-invalid': !isMessageValid && messageBlured,
                  'is-valid': isMessageValid && messageBlured,
                }"
                v-on:blur="messageBlured = true"
                :placeholder="this.$store.getters.getWordLocale('txt_mesaj')"
              ></textarea>
              <div class="invalid-feedback" v-show="!isMessageValid">
                {{ this.$store.getters.getWordLocale("txt_mesaj_giriniz") }}
              </div>

              <div class="mt-4 collapse" id="optional-fields">
                <div class="company-contact-collaps">
                  <h5 class="text-center">
                    <b>{{
                      this.$store.getters.getWordLocale(
                        "txt_istege_bagli_alanlar"
                      )
                    }}</b>
                  </h5>
                  <div
                    id="js-request-form-collapsible"
                    class="mb-3 mt-3 company-contact-collaps-area"
                  >
                    <div class="form-group">
                      <input
                        :placeholder="
                          toTitles(
                            this.$store.getters.getWordLocale('txt_firma_adi')
                          )
                        "
                        v-model="com_companyName"
                        class="form-control mb-3"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        :placeholder="
                          toTitles(
                            this.$store.getters.getWordLocale('txt_adres')
                          )
                        "
                        v-model="com_address"
                        class="form-control mb-3"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        :placeholder="
                          toTitles(
                            this.$store.getters.getWordLocale('txt_web_sitesi')
                          )
                        "
                        v-on:keyup="validURL(com_webAddress)"
                        v-on:focusout="validURL(com_webAddress)"
                        v-model="com_webAddress"
                        class="form-control"
                      />
                    </div>
                    <div
                      style="
                        width: 100%;
                        margin-top: 0.25rem;
                        font-size: 0.875em;
                        color: #dc3545;
                      "
                      v-show="isWebValid == false"
                    >
                      {{
                        this.$store.getters.getWordLocale(
                          "txt_gecerli_web_adres_giriniz"
                        )
                      }}
                    </div>
                    <div class="col-xl-12 mt-3 p-0 row m-0">
                      <div class="form-group col-xl-6 pr-xl-3 p-0 mb-0">
                        <input
                          type="text"
                          :placeholder="
                            toTitles(
                              this.$store.getters.getWordLocale('txt_telefon')
                            )
                          "
                          v-model="com_phone"
                          style="margin-left: -2px"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group col-xl-6 pr-xl-0 p-0 mb-0">
                        <input
                          type="text"
                          :placeholder="
                            toTitles(
                              this.$store.getters.getWordLocale('txt_fax')
                            )
                          "
                          v-model="com_fax"
                          class="form-control"
                        />
                      </div>

                      <div
                        class="col-md-12 mt-2 p-0 communication-platforms"
                        v-show="com_phone != ''"
                      >
                        <div
                          v-for="(platform, pIndex) in communicationPlatforms"
                          :key="pIndex"
                          class="d-flex justify-content-between flex-column"
                        >
                          <div
                            class="
                              foriers-comm-application-used-item
                              custom-control custom-checkbox
                            "
                          >
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="'platform-' + platform.id"
                              v-on:change="
                                setSelectedplatforms(
                                  $event.target.checked,
                                  platform.id
                                )
                              "
                            />
                            <label
                              class="custom-control-label btn btn-light"
                              :for="'platform-' + platform.id"
                              ><i :class="platform.icon"></i
                              ><span>{{ platform.name }}</span></label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button
                ref="submitBtn"
                v-on:click.stop.prevent="submit"
                class="w-100 mt-3 send-msg-button"
              >
                {{ this.$store.getters.getWordLocale("txt_gonder") }}
                <span v-show="sendingMessage"
                  ><i class="fa fa-spinner fa-spin"></i
                ></span>
              </button>

              <div
                class="alert mt-1 alert-success text-center"
                v-show="messageSent"
              >
                <i class="fa fa-info-circle"></i>
                {{
                  this.$store.getters.getWordLocale(
                    "txt_mesajiniz_basariyla_gonderildi"
                  )
                }}
              </div>

              <div
                class="alert mt-1 alert-danger text-center"
                v-show="errorSending"
              >
                <i class="fa fa-info-circle"></i>
                {{
                  this.$store.getters.getWordLocale(
                    "txt_mesaj_gonderirken_hata_olustu"
                  )
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_kategorileri") }}</b>
          </div>
          <div class="card-body">
            <div v-if="categories.length == 0" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_kategori_bilgisi_bulunamadi"
                )
              }}
            </div>
            <div v-else>
              <div v-for="(category, cIndex) in categories" :key="cIndex">
                <i class="far fa-dot-circle"></i> {{ category }}
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_adres") }}</b>
          </div>
          <div class="card-body">
            <div v-if="companyAddress.length == 0" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_adres_bilgisi_bulunamadi"
                )
              }}
            </div>
            <div v-else>
              <div class="mb-2">
                <i class="fas fa-user-tie"></i> {{ contactPerson }}
              </div>
              <div v-for="(address, aIndex) in companyAddress" :key="aIndex">
                <i class="fas fa-map-marker-alt"></i> {{ address }}
                <hr v-show="aIndex + 1 != companyAddress.length" />
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{
              this.$store.getters.getWordLocale("txt_faaliyet_alanlari")
            }}</b>
          </div>
          <div class="card-body">
            <div v-if="segments.length == 0" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_faaliyet_alani_bulunamadi"
                )
              }}
            </div>
            <div v-else>
              <div v-for="(segment, cIndex) in segments" :key="cIndex">
                <i class="far fa-dot-circle"></i> {{ segment }}
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_sertifikalari") }}</b>
          </div>
          <div class="card-body">
            <div v-if="certificates == ''" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_sertifika_bilgisi_bulunamadi"
                )
              }}
            </div>
            <div v-else>
              <i class="far fa-dot-circle"></i> {{ certificates }}
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_marka") }}</b>
          </div>
          <div class="card-body">
            <div v-if="brands == ''" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_marka_bilgisi_bulunamadi"
                )
              }}
            </div>
            <div v-else><i class="far fa-dot-circle"></i> {{ brands }}</div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{
              this.$store.getters.getWordLocale("txt_banaka_hesaplari")
            }}</b>
          </div>
          <div class="card-body">
            <i v-show="banks != ''" class="far fa-dot-circle"></i> {{ banks }}
            <div v-show="banks == ''" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_banka_bilgisi_bulunamadi"
                )
              }}
            </div>
          </div>
        </div>

        <div class="card mt-2">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_calisan_sayisi") }}</b>
          </div>
          <div class="card-body">
            <i class="far fa-dot-circle"></i> {{ employeeCount }}

            <div v-show="employeeCount == ''" class="alert alert-warning">
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_calisan_sayisi_bilgisi_bulunamadi"
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import helper from "./helper.js";
import CountryFlag from "vue-country-flag-next";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

import { mapState } from "vuex";
import Select2 from "vue3-select2-component";

import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  computed: mapState({
    langCodeX: (state) => state.langCodeX,
  }),
  watch: {
    langCodeX() {
      this.showLoader = true;

      this.reBuildCompanyDetails();
      this.reBuildCompanyProducts();
      this.reBuildCompanyCategories();
      this.reBuildCompanySegments();

      setTimeout(() => {
        this.showLoader = false;
      }, 100);
    },
  },
  data() {
    return {
      showLoader: true,
      selectedPlatforms: [],
      communicationPlatforms: [],
      optionalFieldsCollapsed: false,
      countries: [],
      selectedCountryCode: "tr",
      selectedCountry: 66361,
      com_companyName: "",
      com_address: "",
      com_webAddress: "",
      com_phone: "",
      com_fax: "",
      valid: true,
      sendingMessage: false,
      senderNameSurname: "",
      senderEmail: "",
      senderCountry: 0,
      subject: "",
      message: "",
      isWebValid: true,
      isNameValid: true,
      nameBlured: false,
      isEmailValid: true,
      emailBlured: false,
      isSubjectValid: true,
      subjectBlured: false,
      isMessageValid: true,
      messageBlured: false,
      localLangId: "en",
      firstCategoryName: "",
      randomCategoryName1: "",
      randomCategoryName2: "",
      companySegmentsFullData: [],
      companyCategoriesFullData: [],
      companyProductsFullData: [],
      companyDetailsFullData: [],
      fullDescription: false,
      employeeCount: "",
      banks: "",
      certificates: "",
      brands: "",
      memebrshipName: "",
      memebrshipIcon: "",
      companyKeywords: [],
      logo: this.$store.state.defaultLogoX,
      companyName: "",
      companyDescription: "",
      companyCountry: "",
      companyCountryCode: "",
      profiles: [],
      companyDetails: [],
      companyProducts: [
        {
          image: "/storage/images/general/no-image.png",
          title: "",
          description: "",
        },
      ],
      companyCategories: [],
      categories: [],
      segments: [],
      companyAddress: [],
      contactPerson: "",
      companySegments: [],
      companyId: 0,
      isVip: false,
    };
  },
  components: {
    ForieLoader,
    TeLoader,
    CountryFlag,
    Carousel,
    Select2,
    Slide,
    Pagination,
    Navigation,
  },
  methods: {
    setSelectedplatforms(status, id) {
      if (status == true) {
        this.selectedPlatforms.push(id);
      } else {
        var index = this.selectedPlatforms.findIndex((x) => x == id);
        this.selectedPlatforms.splice(index, 1);
      }
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
    submit: function () {
      this.messageSent = false;
      this.errorSending = false;

      this.validate();

      this.isNameValid = this.senderNameSurname == "" ? false : true;
      this.isEmailValid = this.validEmail(this.senderEmail);
      this.isSubjectValid = this.subject == "" ? false : true;
      this.isMessageValid = this.message == "" ? false : true;

      if (this.message.length < 6 || this.message.length > 700) {
        this.isMessageValid = false;
      }

      if (
        this.isNameValid == false ||
        this.isEmailValid == false ||
        this.isSubjectValid == false ||
        this.isMessageValid == false
      ) {
        this.valid = false;
        return 0;
      }
      this.sendMessage();
    },
    validate: function () {
      this.nameBlured = true;
      this.emailBlured = true;
      this.subjectBlured = true;
      this.messageBlured = true;

      if (
        this.checkNameSurname(this.senderNameSurname) &&
        this.validEmail(this.senderEmail) &&
        this.checkSubject(this.subject) &&
        this.checkMessage(this.message)
      ) {
        this.valid = true;
      }
    },
    validEmail: function (email) {
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      if (re.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      this.isWebValid = !!pattern.test(str);
      if (str == "") {
        this.isWebValid = true;
      }
    },
    checkNameSurname(e) {
      this.isNameValid = this.senderNameSurname == "" ? false : true;

      if (e.keyCode == 13) {
        const elem = this.$refs.submitBtn;
        elem.click();
      }
    },
    checkEmail(e) {
      this.isEmailValid = this.validEmail(this.senderEmail);

      if (e.keyCode == 13) {
        const elem = this.$refs.submitBtn;
        elem.click();
      }
    },
    checkSubject(e) {
      this.isSubjectValid = this.subject == "" ? false : true;

      if (e.keyCode == 13) {
        const elem = this.$refs.submitBtn;
        elem.click();
      }
    },
    checkMessage(e) {
      this.isMessageValid = this.message == "" ? false : true;
      if (this.message.length < 6 || this.message.length > 700) {
        this.isMessageValid = false;
      }
      if (e.keyCode == 13) {
        const elem = this.$refs.submitBtn;
        elem.click();
      }
    },
    collapseOptionalFileds() {
      if (this.optionalFieldsCollapsed == false) {
        const elem = this.$refs.messageTxtArea;
        elem.click();
        this.optionalFieldsCollapsed = true;
      }
    },
    async getCommunicationPlatforms() {
      var result = [];
      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/home/getCommunicationPlatforms`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data.responseObject))
        .catch((err) => console.log(err.message));

      this.communicationPlatforms = [];
      if (result != undefined && result != null && result.length > 0) {
        result.forEach((element) => {
          this.communicationPlatforms.push({
            id: element.id,
            name: element.name,
            icon: element.icon,
          });
        });

        console.log(this.communicationPlatforms);
      }
    },
    async sendMessage() {
      if (this.sendingMessage) {
        return 0;
      }

      this.sendingMessage = true;

      this.messageSent = false;
      this.errorSending = false;

      var result = [];

      var selectedCommPlatforms = "";
      if (this.selectedPlatforms.length > 0) {
        selectedCommPlatforms = this.selectedPlatforms.toString();
      }

      this.optionalFieldsCollapsed = false;

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/home/sendMessageToDomainCompanies/?name=${this.senderNameSurname}&subject=${this.subject}&message=${this.message}&countryCode=${this.selectedCountryCode}&email=${this.senderEmail}&companyName=${this.com_companyName}&fax=${this.com_fax}&phone=${this.com_phone}&webSite=${this.com_webAddress}&address=${this.com_address}&communicationPlatformIds=${selectedCommPlatforms}&targetCompanyIds=${this.companyId}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            companyId: this.companyId,
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.sendingMessage = false;
      if (result.resultText == "Success") {
        this.messageSent = true;

        const elem = this.$refs.messageTxtArea;
        elem.click();

        this.clearSendingMessageForm();
      } else {
        this.errorSending = true;
      }
    },
    clearSendingMessageForm() {
      if (this.$store.state.userLoggedInX == false) {
        this.senderNameSurname = "";
        this.senderEmail = "";
      }

      this.subject = "";
      this.message = "";
      this.com_companyName = "";
      this.com_fax = "";
      this.com_phone = "";
      this.com_webAddress = "";
      this.com_address = "";

      this.nameBlured = false;
      this.emailBlured = false;
      this.subjectBlured = false;
      this.messageBlured = false;
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.countries = [];

      tempList.forEach((element) => {
        var countryId = parseInt(element._id);
        var countryCode = element.CountryCode;
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        this.countries.push({
          text: name,
          countryCode: countryCode,
          id: parseInt(countryId),
          flag: element.Flag,
        });
      });
    },
    setSelectedCountry(id) {
      this.selectedCountry = parseInt(id);
      this.selectedCountryCode = this.countries.filter(
        (q) => q.id == id
      )[0].countryCode;
      this.selectedCountryCode = this.selectedCountryCode.toLowerCase();
    },
    toSeoFormat(text) {
      try {
        var companyKeywords1 = "";
        var companyKeywords5 = "";
        if (
          this.companyKeywords != "" &&
          this.companyKeywords != null &&
          this.companyKeywords != undefined
        ) {
          companyKeywords1 = this.companyKeywords[0];
          companyKeywords5 = this.companyKeywords.slice(0, 5).join(",");
        }
        text = text
          .replace("[DomainName]", this.$store.state.defaultDomainX)
          .replace("[CompanyName]", this.companyName)
          .replace("[RandomCompanyName]", this.companyName)
          .replace("[CompanyDescription]", this.companyDescription)
          .replace("[RandomDescription]", this.companyDescription)
          .replace("[CompanyKeywords]", this.companyKeywords)
          .replace("[RandomKeywords:1]", companyKeywords1)
          .replace("[RandomKeywords:5]", companyKeywords5)
          .replace("[Country]", this.companyCountry)
          .replace("[Category]", this.firstCategoryName)
          .replace("[RandomCategory:1]", this.randomCategoryName1)
          .replace("[RandomCategory:2]", this.randomCategoryName2)
          .replace("[LeadTitle]", "")
          .replace("[RandomLeadTitle]", "")
          .replace("[LeadKeywords]", "")
          .replace("[RandomLeadKeywords:1]", "")
          .replace("[RandomLeadKeywords:5]", "")
          .replace("[ProductName]", "")
          .replace("[RandomCategory:1]", "")
          .replace("[RandomCategory:2]", "")
          .replace("[LeadCategory]", "")
          .replace("[LeadSubCategory]", "")
          .replace("[RandomLeadCategory:1]", "")
          .replace("[RandomLeadCategory:2]", "");

        return text;
      } catch (error) {
        return text;
      }
    },
    async getCompany() {
      this.showLoader = true;
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompany`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: parseInt(this.companyId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyDetails = data))
        .catch((err) => console.log(err.message));

      this.companyDetailsFullData = this.companyDetails;
      if (this.companyDetails == null) {
        window.location.href = `/${this.$store.state.langCodeX}/not-found`;
      }
      this.logo =
        this.companyDetails.Logo == null
          ? this.$store.state.defaultLogoX
          : `https://cdn.turkishexporter.com.tr${this.companyDetails.Logo}`;

      this.logo = this.logo.toLowerCase();
      if (
        this.logo.indexOf(`companies/logo/1`) != -1 ||
        this.logo.indexOf(`companies/logo/logo`) != -1
      ) {
        this.logo = this.$store.state.defaultLogoX;
      }
      helper.setCoverImage(this.companyDetails.BackgroundImage);
      this.companyName =
        this.companyDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.companyDescription =
        this.companyDetails.Localizations.filter(
          (q) =>
            q.LangCode == this.$store.state.langCodeX &&
            q.DescriptionContent != null
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].DescriptionContent
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].DescriptionContent;

      this.fullDescription =
        this.companyDescription.length >= 250 ? false : true;

      this.companyKeywords =
        this.companyDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Keywords
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Keywords;
      this.companyKeywords = this.companyKeywords.split(",");

      this.companyCountry =
        this.companyDetails.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetails.Country.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.companyCountryCode =
        this.companyDetails.Country[0].Icon == null ||
        this.companyDetails.Country[0].Icon == ""
          ? ""
          : this.companyDetails.Country[0].Icon.toLowerCase();

      this.companyDetails.Localizations.forEach((element) => {
        var flagCode = element.LangCode;
        this.profiles.push(flagCode);
      });

      this.companyDetails.Categories.forEach((element) => {
        var categoryId = parseInt(element.MainCategoryId);
        this.companyCategories.push(categoryId);
      });

      this.companyDetails.Segments.forEach((element) => {
        var segmentId = parseInt(element);
        this.companySegments.push(segmentId);
      });

      this.isVip = this.companyDetails.IsVip;
      this.showLoader = false;
      this.getCompanyCategories();
      this.proccssSeoSettings();
      this.getCompanyProducts();
    },
    proccssSeoSettings() {
      if (this.$store.state.companyDetailsTitleX == "") {
        this.$store.state.detailsTitleX = this.companyName;
      } else {
        this.$store.state.detailsTitleX = this.toSeoFormat(
          this.$store.state.companyDetailsTitleX
        );
      }

      if (this.$store.state.companyDetailsDescriptionX == "") {
        this.$store.state.detailsDescriptionX = this.companyDescription;
      } else {
        this.$store.state.detailsDescriptionX = this.toSeoFormat(
          this.$store.state.companyDetailsDescriptionX
        );
      }

      if (this.$store.state.companyDetailsKeywordsX == "") {
        this.$store.state.detailsKeywordsX = this.companyKeywords;
      } else {
        var temp = [];
        var isArray = Array.isArray(this.$store.state.companyDetailsKeywordsX);
        if (
          this.$store.state.companyDetailsKeywordsX.length > 0 &&
          isArray == true
        ) {
          this.$store.state.companyDetailsKeywordsX.forEach((element) => {
            var text = element.text;
            temp.push(text);
          });
          this.$store.state.detailsKeywordsX = temp;
        } else {
          this.$store.state.detailsKeywordsX = this.toSeoFormat(
            this.$store.state.companyDetailsKeywordsX
          );
        }
      }
    },
    async getCompanyProducts() {
      var companies = [parseInt(this.companyId)];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyProducts`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: companies,
            count: 20,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyProducts = data))
        .catch((err) => console.log(err.message));

      this.companyProductsFullData = this.companyProducts;

      var temp = [];
      if (this.companyProducts.length > 0) {
        this.companyProducts = this.companyProducts[0].Products;

        this.companyProducts.forEach((product) => {
          if (product.Images.length > 0) {
            var image = product.Images[0].Image;
            var title =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Name
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name;

            var fullTitle = title;
            title = title.length > 30 ? `${title.substr(0, 30)}...` : title;

            var description =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Description
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Description;

            temp.push({
              image: image,
              title: title,
              fullTitle: fullTitle,
              description: description,
            });
          }
        });

        this.companyProducts = [];
        this.companyProducts = temp;
      }
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    getCompanyCategories() {
      var categories = [];
      if (this.companyCategories.length > 0) {
        var unique = this.companyCategories.filter(this.onlyUnique);
        unique.forEach((ele) => {
          var category = this.$store.state.mainCategoriesX.filter(
            (q) => parseInt(q._id) == ele
          );
          categories.push(category);
        });
      }
      this.companyCategories = categories;
      if (this.companyCategories.length > 0) {
        this.companyCategoriesFullData = categories;
        this.companyCategories.forEach((category) => {
          var categoryName =
            category[0].Localizations.length == 0
              ? ""
              : category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : category[0].Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          this.categories.push(categoryName);
        });
        this.firstCategoryName = this.categories[0];
        this.categories = this.categories.sort(() => 0.5 - Math.random());
        this.randomCategoryName1 = this.categories[0];
        this.randomCategoryName2 = this.categories[0];
        if (this.categories.length > 1) {
          this.randomCategoryName2 = `${this.categories[1]},${this.categories[0]}`;
        }
        this.getCompanySegments();
      }
    },
    async getCompanySegments() {
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanySegments`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            segments: this.companySegments,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companySegments = data))
        .catch((err) => console.log(err.message));

      if (this.companySegments.length > 0) {
        this.companySegmentsFullData = this.companySegments;
        this.companySegments.forEach((segment) => {
          var segmentName =
            segment.Localizations.length == 0
              ? ""
              : segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : segment.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          this.segments.push(segmentName);
        });
        this.getCompanyInformation();
      }
    },
    async getCompanyInformation() {
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: parseInt(this.companyId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyDetails = data))
        .catch((err) => console.log(err.message));

      if (this.companyDetails != null) {
        this.memebrshipName =
          this.companyDetails.CompanyActiveMembership.Localizations.length == 0
            ? ""
            : this.companyDetails.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              ).length > 0
            ? this.companyDetails.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : this.companyDetails.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        this.memebrshipIcon = this.companyDetails.CompanyActiveMembership.Icon;

        this.companyDetails.CompanyContactInformations.forEach((element) => {
          var address = element.Address;
          this.companyAddress.push(address);
          if (this.contactPerson == "") {
            this.contactPerson = element.ContactPearson;
          }
        });

        this.brands = this.companyDetails.CompanyCustomFields.Brands;
        this.certificates =
          this.companyDetails.CompanyCustomFields.Certificates;
        this.banks = this.companyDetails.CompanyCustomFields.Banks;
        this.employeeCount =
          this.companyDetails.CompanyCustomFields.PersonelCount;
      }
    },
    reBuildCompanyDetails() {
      this.companyName =
        this.companyDetailsFullData.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.companyDescription =
        this.companyDetailsFullData.Localizations.filter(
          (q) =>
            q.LangCode == this.$store.state.langCodeX &&
            q.DescriptionContent != null
        ).length > 0
          ? this.companyDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].DescriptionContent
          : this.companyDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].DescriptionContent;

      this.fullDescription =
        this.companyDescription != null
          ? this.companyDescription.length >= 250
            ? false
            : true
          : true;

      this.companyKeywords =
        this.companyDetailsFullData.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Keywords
          : this.companyDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Keywords;
      this.companyKeywords =
        this.companyKeywords != null ? this.companyKeywords.split(",") : [];

      this.companyCountry =
        this.companyDetailsFullData.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetailsFullData.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetailsFullData.Country.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.proccssSeoSettings();
    },
    reBuildCompanyProducts() {
      var temp = [];
      if (this.companyProducts.length > 0) {
        this.companyProducts = this.companyProductsFullData[0].Products;

        this.companyProducts.forEach((product) => {
          var image = product.Images[0].Image;
          var title =
            product.Localizations.length == 0
              ? ""
              : product.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? product.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : product.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;
          var fullTitle = title;
          title = title.length > 30 ? `${title.substr(0, 30)}...` : title;

          var description =
            product.Localizations.length == 0
              ? ""
              : product.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? product.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Description
              : product.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Description;

          temp.push({
            image: image,
            title: title,
            fullTitle: fullTitle,
            description: description,
          });
        });

        this.companyProducts = [];
        this.companyProducts = temp;
      }
    },
    reBuildCompanyCategories() {
      if (this.companyCategoriesFullData.length > 0) {
        this.categories = [];
        this.companyCategoriesFullData.forEach((category) => {
          var categoryName =
            category[0].Localizations.length == 0
              ? ""
              : category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : category[0].Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          this.categories.push(categoryName);
        });
      }
    },
    reBuildCompanySegments() {
      if (this.companySegmentsFullData.length > 0) {
        this.segments = [];
        this.companySegmentsFullData.forEach((segment) => {
          var segmentName =
            segment.Localizations.length == 0
              ? ""
              : segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : segment.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          this.segments.push(segmentName);
        });
      }
    },
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
  },
  created() {
    if (this.$store.state.userLoggedInX) {
      this.senderNameSurname = this.$store.state.userNameX;
      this.senderEmail = this.$store.state.userEmailX;
    }
    this.localLangId = helper.getLangCode();
    this.$store.state.langCodeX = this.localLangId;
    this.companyId = helper.getCompanyId(this.$route.params.id);
    this.getCountries();
    this.getCommunicationPlatforms();
    this.getCompany();
  },
};
</script>


<style scoped>
.company-country small {
  margin-top: 10px;
  margin-left: 4px;
  font-weight: 900;
  font-size: 12px;
}

.is-company-vip small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
  font-size: 12px;
}

.is-company-vip {
  margin-top: 9px;
  margin-left: 6px;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.company-keywords {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  max-height: 62px;
  overflow: hidden;
}
.company-keywords span {
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  border: solid 1px #dfe5ee;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  margin-top: 5px;
  margin-right: 5px;

  font-size: 12px;
}

.company-logo {
  width: 100%;
  height: 125px;
  border: 1px solid #d8d8d8;
  padding: 2px;
  margin: 2px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.carousel button {
  background-color: #000 !important;
}
.carousel__item {
  max-height: 150px;
  width: 100%;
  background-color: #f7f7f7;
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.carousel__pagination-button--active {
  background-color: red !important;
}

.carousel__item img {
  width: 130px;
  height: 130px;
}

.read-more {
  cursor: pointer;
}

.selected-lang {
  box-shadow: 0px 1px 16px 10px #000000;
}

.send-msg-button {
  width: 100%;
  font-size: 14px;
  background-color: #2a2a2a !important;
  border: none;
  font-weight: 600;
  color: #fff;
  outline: none !important;
  padding: 14px 0px;
  transition: background-color 0.5s, color 0.5s;
  cursor: pointer;
}

.send-msg-button:hover {
  background-color: #dfe5ee !important;
  color: #565656 !important;
}
.contact-supplier {
  display: block;
  width: 228px;
  height: 32px;
  line-height: 32px;
  border-radius: 18px;
  border: 0;
  background-color: #0a6798 !important;
  color: #fff;
  font-size: 14px;
  text-align: center;
  margin: 12px auto;
}

.foriers-comm-application-used-item {
  padding: 0 !important;
  display: inline-block;
  background-color: transparent;
  margin-bottom: 10px;
}

.companies_send_message .select2-selection,
.companies_send_message input,
.companies_send_message textarea {
  border-radius: 6px;
  border: solid 1px #dfe5ee;
}

.btn.btn-light {
  font-size: 14px;
  font-weight: 700;
  padding: 10px 12px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  border-radius: 8px;
  transition: color 0.5s, background-color 0.5s;
  background: #fff;
  border: 1px solid #dfe5ee;
}

.foriers-comm-application-used-item > label {
  top: 0;
  display: inline-flex !important;
  align-items: center;
  background-color: #f7f8f9;
  width: 100%;
}

.foriers-comm-application-used-item > label > i {
  font-size: 22px;
  padding: 0px 5px 0px 19px;
  color: #00245d;
  background-color: #fff;
  border-radius: 6px 0px 0px 6px;
  box-shadow: 0px 0px 0px 1px #dfe5ee;
  line-height: 1.46;
}

.foriers-comm-application-used-item > label > span {
  font-size: 12px;
  font-weight: 500;
  color: #00245d;
  line-height: 1;
  background-color: #fff;
  padding: 10px;
  border-radius: 0px 6px 6px 0px;
  border: 1px solid #dfe5ee;
  width: 100%;
}

.foriers-comm-application-used-item > label:before,
.foriers-comm-application-used-item > label:after {
  top: 0;
  bottom: 0;
  left: 5px;
  margin: auto;
}

.foriers-comm-application-used-item > label:before,
.foriers-comm-application-used-item > label:after {
  top: 0;
  bottom: 0;
  left: 5px;
  margin: auto;
}

.custom-control-input {
  position: absolute;
  margin-top: 21px;
  left: 10px;
}

.selected-platform {
  border-color: #50b04d;
}

.char-count {
  color: #a3a9af;
}

.page-laoder {
  background: #ffffff96 !important;
}
</style>